import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import axios, { CancelToken } from 'axios';
import invariant from 'invariant';
import interceptors from './_interceptors';
import { DEFAULT_CONFIG } from './_constants';
import { conveyTrashable, makeTrashable } from './_helpers';

var Request = function () {
  _createClass(Request, [{
    key: "isInitialized",
    get: function get() {
      return this._isInitialized;
    }
  }, {
    key: "interceptors",
    get: function get() {
      invariant(this._isInitialized && this._instance, "[@insolus/request] L'initialisation (`Request.init({ ... })`) doit " + "\xEAtre effectu\xE9e avant toute modification des intercepteurs.");
      return this._instance.interceptors;
    }
  }]);

  function Request(config) {
    _classCallCheck(this, Request);

    this._isInitialized = false;

    if (config) {
      this.init(config);
    }
  }

  _createClass(Request, [{
    key: "init",
    value: function init() {
      var _this$interceptors$re;

      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      invariant(!this._isInitialized, "[@insolus/request] Request a d\xE9j\xE0 \xE9t\xE9 initialis\xE9.");
      this._isInitialized = true;

      var _config = _objectSpread(_objectSpread({}, DEFAULT_CONFIG), config);

      this._instance = axios.create(_config);
      this.interceptors.request.use(interceptors.request, function (err) {
        return Promise.reject(err);
      });

      (_this$interceptors$re = this.interceptors.response).use.apply(_this$interceptors$re, _toConsumableArray(interceptors.response));
    }
  }, {
    key: "exec",
    value: function exec(config) {
      invariant(this._isInitialized, "[@insolus/request] L'initialisation (`Request.init({ ... })`) doit \xEAtre " + "effectu\xE9e avant tout appel aux m\xE9thodes de requ\xEAtes.");

      var cancel = function cancel() {};

      var _config = Object.assign({}, config, {
        cancelToken: new CancelToken(function (c) {
          cancel = c;
        })
      });

      var promise = this._instance.request(_config);

      return makeTrashable(promise, cancel);
    }
  }]);

  return Request;
}();

['delete', 'get', 'head', 'options'].forEach(function (method) {
  Request.prototype[method] = function (url) {
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var xhrPromise = this.exec(_objectSpread(_objectSpread({}, config), {
      method: method,
      url: url
    }));
    return conveyTrashable(xhrPromise, function (promise) {
      return promise.then(function (_ref) {
        var headers = _ref.headers,
            data = _ref.data;
        return ['head', 'options'].indexOf(method) !== -1 ? headers : data;
      });
    });
  };
});
['post', 'put', 'patch'].forEach(function (method) {
  Request.prototype[method] = function (url) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var xhrPromise = this.exec(_objectSpread(_objectSpread({}, config), {
      method: method,
      data: data,
      url: url
    }));
    return conveyTrashable(xhrPromise, function (promise) {
      return promise.then(function (_ref2) {
        var _data = _ref2.data;
        return _data;
      });
    });
  };
});
export default Request;